import { render, staticRenderFns } from "./IconWarning.vue?vue&type=template&id=01d14a0d&"
import script from "./IconWarning.vue?vue&type=script&lang=js&"
export * from "./IconWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports